export const getNextPageMappings = () => {
    const nextPageMappings = [];
    /* Mapping of next page name based feature flag values: The goal is to have feature flagging based re-routing of
   pages in the event multiple pages need to be feature toggled so it can be dynamic to accommodate that as well.
   For each page mapping we are checking the relevant feature toggle and then adding mappings of which page
   we want the current next page to be replaced and adding it to the list only if the feature toggle is disabled.
   Example:
     const shouldSkipCarConnectedQuestions = !getFeatureFlag('carConnectedQuestions');
      if (shouldSkipCarConnectedQuestions) {
        nextPageMappings.push({
            regular_driver_licence_type: 'regular_driver_licence_age',
            youngest_driver_licence_type: 'youngest_driver_licence_age'
        });
    }
   */
    return nextPageMappings;
};
